(ns admin.components.learner-reports.post-test-analysis
  (:require [potpuri.core :as pot]

            [kyber.components.base.icons :as icons]
            [kyber.components.base.text :as text]
            [kyber.components.composite.expander :as expander]
            [kyber.styles.core :refer [gs styles->classes]]
            [kyber.utils :as ku]

            [admin.components.learner-reports.shared :as lrs]
            [admin.components.learner-reports.question-body :as question-body]))

(def classes
  (styles->classes
   {:question-container
    {:border-top (str "1px solid " (gs [:colors :gray-scale-200]))
     :padding [(gs [:spacing :p8])
               (gs [:spacing :p0])]}

    :attempt-column-header
    {:text-align :right
     :padding [(gs [:spacing :p8])
               (gs [:spacing :p4])
               (gs [:spacing :p12])]
     "& p"
     {:margin "0px"}

     "& span.label"
     {:margin-right (gs [:spacing :p8])}

     "& span.attempt"
     {:width (gs [:spacing :p32])
      :display :inline-block
      :text-align :center
      :padding [(gs [:spacing :p0])
                (gs [:spacing :p0])]}}

    :item-group
    {:display :flex
     :align-items :center}

    :question-title-group
    {:flex-grow 1
     :width "0px"}

    :question-title
    {:padding [(gs [:spacing :p4])
               (gs [:spacing :p20])
               (gs [:spacing :p4])
               (gs [:spacing :p0])]
     :white-space :nowrap
     :overflow :hidden
     :text-overflow :ellipsis
     :width "100%"}

    :key-question
    {:background (gs [:colors :true-black])
     :color (gs [:colors :true-white])
     :border-radius (gs [:radius :r40])
     :display :inline-block
     :margin-right (gs [:spacing :p8])
     :padding [(gs [:spacing :p4])
               (gs [:spacing :p8])]}

    :guessed-pill
    {:background (gs [:colors :warning-500])
     :color (gs [:colors :true-black])
     :border-radius (gs [:radius :r40])
     :padding [(gs [:spacing :p4])
               (gs [:spacing :p8])]}

    :learning-objective-pill
    {:border-radius (gs [:radius :r40])
     :border (str "1px solid " (gs [:colors :gray-scale-300]))
     :padding [(gs [:spacing :p4])
               (gs [:spacing :p8])]}

    :header-row-icon
    {:width (gs [:spacing :p32])
     :margin [(gs [:spacing :p0])
              (gs [:spacing :p0])]
     :text-align :center}}))

(defn- post-test-header-results
  [{:keys [total-attempts first-attempt last-attempt]}]
  (let [correct-icon
        [icons/icon {:class (:header-row-icon classes)
                     :style {:color (gs [:colors :success-500])}} :check-regular]

        incorrect-icon
        [icons/icon {:class (:header-row-icon classes)
                     :style {:color (gs [:colors :error-700])}} :times]

        make-icon #(if (true? %)
                     correct-icon
                     incorrect-icon)]
    [:div {:class (:item-group classes)}
     (when (= "guess" (:learner-confidence first-attempt))
       [text/caption-10 :span {:class (:guessed-pill classes)}
        "guessed"])
     (make-icon first-attempt)
     (when (> total-attempts 2)
       [text/body-10 :span "..."])
     (when (> total-attempts 1)
       (make-icon last-attempt))]))

(defn- question-item-header
  [{key-question :question/key
    :question/keys [has-correctness
                    body
                    index
                    last-attempt
                    first-attempt
                    total-attempts]
    :question.context/keys [learning-objective]}]
  (let [{:learning-objective/keys [label]} learning-objective
        {:question.response/keys [status]} first-attempt]
    [:div {:class (:item-group classes)
           :style {:flex-grow 1}}
     (when (true? has-correctness)
       [lrs/question-status status])
     [:div (cond-> {:class (:question-title-group classes)}
             (true? has-correctness)
             (assoc-in [:style :margin-left] (gs [:spacing :p12])))
      [:div {:class (:question-title classes)}
       [text/title-20 :span
        (str "Q" (inc index) " " (some-> body ku/sanitize-rich-text))]]

      (when (or (true? key-question)
                (some? label))
        [:div {:class (:item-group classes)}
         (when (true? key-question)
           [text/caption-10 :span {:class (:key-question classes)} "KEY"])
         (when (some? label)
           [text/caption-10 :span {:class (:learning-objective-pill classes)}
            label])])]

     (when (true? has-correctness)
       [post-test-header-results {:total-attempts total-attempts
                                  :first-attempt (:question.response/correct? first-attempt)
                                  :last-attempt (:question.response/correct? last-attempt)}])]))

(defn- question-item [{:question.context/keys [resources] :as question} user-uuid]
  [:li {:class (:question-container classes)}
   [expander/render
    {:header [question-item-header question]
     :body [question-body/render {:question question
                                  :resources resources
                                  :is-moment false
                                  :user-uuid user-uuid}]}]])

(defn- question-items [{:keys [data]}]
  (let [{:activity/keys [post-test]
         {pre-test-engagement :activity-session/pre-test
          post-test-engagement :activity-session/post-test
          user-uuid :user/uuid} :learner/data}
        data

        total-attempts
        (get post-test-engagement :questionnaire.attempts/count)

        pre-test-attempt-lookup
        (pot/index-by :question/uuid
                    (get-in pre-test-engagement [:questionnaire.attempts/first
                                                 :questionnaire.attempt/questions]))

        first-attempt-lookup
        (pot/index-by :question/uuid
                    (get-in post-test-engagement [:questionnaire.attempts/first
                                                  :questionnaire.attempt/questions]))

        last-attempt-lookup
        (pot/index-by :question/uuid
                    (get-in post-test-engagement [:questionnaire.attempts/last
                                                  :questionnaire.attempt/questions]))]
    
    
    [:ul
     (map-indexed
      (fn [index {:question.aggregates/keys [percent-correct responses]
                 learning-objective :question.context/learning-objective
                 {question-uuid :question/uuid :as question} :question.context/question}]
        ^{:key question-uuid}
        [question-item (assoc question
                              :question/index index
                              :question/total-attempts total-attempts
                              :question/pre-test-attempt (get pre-test-attempt-lookup question-uuid)
                              :question/first-attempt (get first-attempt-lookup question-uuid)
                              :question/last-attempt (get last-attempt-lookup question-uuid)
                              :question.context/learning-objective learning-objective
                              :question.aggregates/percent-correct percent-correct
                              :question.aggregates/responses responses) user-uuid])
      (:assessment/questions post-test))]))

(defn- render-label [{:activity/keys [post-test] :as data}]
  (let [all-ungraded? (not-any? :question/has-correctness (get post-test :questionnaire/questions))
        total-attempts (get-in data [:learner/data :activity-session/post-test :questionnaire.attempts/count])]
    (when (and (not all-ungraded?)
               (pos? total-attempts))
      [text/body-20 :p {:class (:attempt-column-header classes)}
       [:span
        [text/body-20 :span.label "Post-test Attempt:"]
        [text/body-20 :span.attempt {} (ku/get-ordinal 1)]
        (when (> total-attempts 1)
          [:<>
           (when (> total-attempts 2)
             [text/body-10 :span "..."])
           [text/body-20 :span.attempt {}
            (ku/get-ordinal total-attempts)]])]])))

(defn- render-title [data]
  (let [total-attempts (get-in data [:learner/data :activity-session/post-test :questionnaire.attempts/count])]
    [lrs/render-chart-header-title
     (str "Post-test Analysis"
          (when (pos? total-attempts)
            (str " (" total-attempts " "
                 (ku/pluralize "attempt" total-attempts)
                 ")")))]))

(defn render [data _options]
  (lrs/render-chart-widget
   {:title-component render-title
    :label-component render-label
    :chart-component question-items
    :data data}))
